// extracted by mini-css-extract-plugin
module.exports = {"socialsWrap":"Socials_socialsWrap__3Hk1-","socialsList":"Socials_socialsList__1hStf","imgLink":"Socials_imgLink__3lMnY","img":"Socials_img__1Nwl6"};